import request from '@/utils/request'
import { cmsServerContext } from '@/config/config'

export function getChargingPrice(myPage) {
  return request({
    url: cmsServerContext + '/chargingPrice/list',
    method: 'post',
    data: myPage
  })
}

export function getChargingByCustomerId(condition) {
  return request({
    url: cmsServerContext + '/chargingPrice/getChargingByCustomerId',
    method: 'post',
    data: condition
  })
}

export function save(chargingPrices) {
  return request({
    url: cmsServerContext + '/chargingPrice/save',
    method: 'post',
    data: chargingPrices
  })
}

export function verifyChargingPrice(chargingPrice) {
  return request({
    url: cmsServerContext + '/chargingPrice/verify',
    method: 'post',
    data: chargingPrice
  })
}

export function remove(chargingPriceId) {
  return request({
    url: cmsServerContext + '/chargingPrice/remove/' + chargingPriceId,
    method: 'get'
  })
}

export function detailSave(detailMap) {
  return request({
    url: cmsServerContext + '/chargingPrice/detailSave',
    method: 'post',
    data: detailMap
  })
}
